const ru = require('./i18n/ru')
const en = require('./i18n/en')

module.exports = {
  ru,
  en,
}
